import type {
  GetAssetMarkerProps,
  GetLocationMarkerProps,
  GetSectorMarkerProps,
} from "./marker.type";
import type { MapMarker } from "@/modules/map";

import { createMapMarker } from "@/modules/map";
import { scaleMarkerCircleSize } from "@/modules/marker";
import { getModelLink } from "@/modules/model-link";

export const getLocationMarker = ({
  context,
  model,
  position,
  scale,
  children,
}: GetLocationMarkerProps): MapMarker | null => {
  return createMapMarker({
    type: "location",
    key: `marker-location-${model?.id}`,
    name: model?.name ?? "",
    position,
    to: getModelLink("location", { context, id: model.id }),
    iconScale: scale,
    anchorOffset: 0,
    children,
  });
};

export const getSectorMarker = ({
  context,
  model,
  position,
  scale,
  children,
}: GetSectorMarkerProps): MapMarker | null => {
  return createMapMarker({
    type: "sector",
    key: `marker-sector-${model?.id}`,
    name: model?.name ?? "",
    position,
    to: getModelLink("sector", { context, id: model.id }),
    iconScale: scale,
    anchorOffset: 0,
    children,
  });
};

export const getAssetMarker = ({
  context,
  model,
  position,
  color,
  scale,
  children,
}: GetAssetMarkerProps): MapMarker | null => {
  const { height } = scaleMarkerCircleSize(scale);

  // Marker is vertically centered, so anchor is half the height
  const anchorOffset = -height / 2;

  return createMapMarker({
    type: "asset",
    key: `marker-asset-${model?.id}`,
    name: model?.name ?? "",
    position,
    to: getModelLink("asset", { context, id: model.id }),
    iconScale: scale,
    iconColor: color,
    chipColor: color,
    anchorOffset,
    children,
  });
};
